module.exports = __webpack_public_path__ + "img/2cf4ff3518c75b3421838b3c6e6f9d82.2cf4ff35.png";